import React, { useEffect, useState } from "react";
import ReactCookieConsent, { VISIBILITY_OPTIONS } from "react-cookie-consent";
import { FormattedMessage, useIntl } from "react-intl";
import { acceptCookies, COOKIE_CONSENT_NAME, declineCookies, onOpenCookieSettings } from "../../../utils/cookieConsent";
import { FRONT_LINKS } from "../../../utils/frontConstants";
import { useSiteLink } from "../../../utils/useSiteLink";
import styles from "./CookieConsent.scss";

const msgKey = "cookieConsent";

/**
 * Small card in the bottom right corner. The library's own styles are disabled.
 * Shown until the visitor accepts or declines, and again when they open the cookie settings (e.g. from the footer).
 */
export const CookieConsent = () => {
    const intl = useIntl();
    const siteLink = useSiteLink();
    const [reopened, setReopened] = useState(false);

    useEffect(() => onOpenCookieSettings(() => setReopened(true)), []);

    const handleAccept = () => {
        setReopened(false);
        acceptCookies();
    };

    const handleDecline = () => {
        setReopened(false);
        declineCookies();
    };

    return (
        <ReactCookieConsent
            disableStyles
            location="none"
            visible={reopened ? VISIBILITY_OPTIONS.SHOW : VISIBILITY_OPTIONS.BY_COOKIE_VALUE}
            cookieName={COOKIE_CONSENT_NAME}
            expires={150}
            enableDeclineButton
            flipButtons
            onAccept={handleAccept}
            onDecline={handleDecline}
            buttonText={<FormattedMessage id={`${msgKey}.accept`} />}
            declineButtonText={<FormattedMessage id={`${msgKey}.decline`} />}
            ariaAcceptLabel={intl.formatMessage({ id: `${msgKey}.acceptLabel` })}
            ariaDeclineLabel={intl.formatMessage({ id: `${msgKey}.declineLabel` })}
            containerClasses={styles.base}
            contentClasses={styles.content}
            buttonWrapperClasses={styles.buttons}
            buttonClasses={styles.accept}
            declineButtonClasses={styles.decline}
        >
            <FormattedMessage
                id={`${msgKey}.message`}
                values={{
                    a: (msg) => (
                        <a href={`${siteLink(FRONT_LINKS.privacy)}#cookies`} target="_blank" rel="noreferrer">
                            {msg}
                        </a>
                    )
                }}
            />
        </ReactCookieConsent>
    );
};
